<template>
  <div class="switch">
    <div class="switch__content">
      <AllowWebCallSwitch
        :data="dataObject"
        class="switch__item--border"
        @update="updateDataObject"
      />
    </div>
  </div>
</template>

<script>
import AllowWebCallSwitch from './AllowWebCallSwitch'
export default {
  name: 'AllowWebCall',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    AllowWebCallSwitch
  },
  data () {
    return {
      dataObject: {} // 该组件和子组件用这个值
    }
  },
  methods: {
    setDataObject (val = {}) {
      this.dataObject = {
        ...this.data,
        ...this.dataObject,
        ...val
      }
    },

    updateDataObject (val = {}) {
      this.setDataObject(val)
    }
  },
  watch: {
    data: {
      /** 监听入参，入参变了更改dataObject */
      deep: true,
      handler (val) {
        this.setDataObject(val)
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.switch {
  margin-bottom: 24px;
  padding: 0 16px;
}

.switch__content {
  background-color: #fff;
  border: 1px solid $gray-2;
  max-width: 840px;
  transition: box-shadow .26s;

  &:hover {

    @media (min-width: 992px) {
      box-shadow: 0 1px 6px rgba(#000, .25);
    }
  }
}

.switch__item--border {
  border-bottom: 1px solid $gray-2;
}
</style>
